import { GET_CT_DISABLED_EVENT_LIST_URL } from "../../api/common/constant";
import { NUDGE_CITY_LIST } from "../../api/locationLock/constant";

const endpointConst = {
  ctDisabledEvents: GET_CT_DISABLED_EVENT_LIST_URL(),
  geojs: "geojs",
  nudgeCityList: NUDGE_CITY_LIST,
  getIntDeliveryForRakhi: "getIntDeliveryForRakhi",
};

const cacheKeyConst = {
  [endpointConst.ctDisabledEvents]: "ctDisabledEvents",
  [endpointConst.geojs]: "geojs",
  [endpointConst.nudgeCityList]: NUDGE_CITY_LIST,
  [endpointConst.getIntDeliveryForRakhi]: "getIntDeliveryForRakhi",
};

export { endpointConst, cacheKeyConst };
